import React from "react";

function NotFound() {
  return (
    <div>
      <h1 className="center">404</h1>
      <h1 className="center">The page your looking for is not found.</h1>
    </div>
  );
}

export default NotFound;
